<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6E1XcZ/tc-custom/9781909166332.jpg?1705237080025" alt="This image is the cover for the book Alfie's War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Alfie's War
      </h1>
      <p class="bookDescription body article font2">
        <b>The bestselling author of <i>Seven Seas, Nine Lives</i> continues the remarkable experiences of Captain A.W.F. “Alfie” Sutton during the Second World War.</b><br/><br/> Written in three parts, this book follows the harrowing adventures of Captain A.W.F. “Alfie” Sutton, CBE, DSC and bar, RN. During events which come as close to fiction as is imaginable, the first part describes how Alfie, badly injured and close to death during the bombing of HMS <i>Illustrious</i> by the Luftwaffe in January 1941, wakes to find himself laid out among the dead, but miraculously still able to help the ship on to Malta. After full recovery, part two starts with his involvement in the Allied campaign in Greece in the spring of 1941, leading to him eventually evacuating the Greek royal family in a flying boat. After numerous escapades he fights with the defenders during the German invasion of Crete in 1941. Admiral Cunningham was later to describe Sutton’s efforts as “an example of grand personal courage under the worst possible conditions which stands out brightly in the gloom.” It was a struggle doomed to failure, but Alfie survived to continue his war and tell his story to author Richard Pike who relates it here with passion, pace and drama.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Pike
      </h2>
      
      <p class="authorDescription body article">Richard Pike became a flight cadet in 1961 at the RAF College, Cranwell, where on graduation, he was awarded the Dickson Trophy and Michael Hill memorial prize for flying. In the early stages of his forty-year flying career he flew the English Electric Lightning before converting to the McDonnell Douglas F-4 Phantom. On leaving the Royal Air Force he became a civilian helicopter pilot. His duties took him to a wide variety of destinations at home and overseas including the Falkland Islands not long after the end of the Falklands War. His last assignment was in Kosovo helping to distribute emergency humanitarian aid on behalf of the United Nations World Food Programme. He and his wife live in Aberdeenshire. He is the author of several Grub Street titles including: Lightning Boys, Lightning Boys 2, Hunter Boys and Phantom Boys Volume 1 and 2.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grub Street Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b850b7ec